import { buildResourceHeaderProps } from 'modules/planning/roles/resourceHeader'
import { getColumnDefinition } from 'modules/planning/roles/columnDefinition'

import type { PeriodDetailData } from 'modules/planning/roles/resourceHeader'
import type {
  HeadcountColumn,
  ColumnDefinitionSources,
} from 'modules/planning/roles/columnDefinition'
import type { ResourceHeadersPropsWithActions } from 'modules/core/lib/navigation/types'
import {
  getCapabilities,
  type PeriodRoleContext,
  type PlanningCapability,
} from 'modules/planning/roles/capabilities'

export type { PeriodRoleContext } from 'modules/planning/roles/capabilities'
export { getCapabilities } from 'modules/planning/roles/capabilities'

type ResourceHeaderBuilder = (period: PeriodDetailData) => ResourceHeadersPropsWithActions

type ColumnDefinitionBuilder = (sources?: ColumnDefinitionSources) => HeadcountColumn[]

export function getResourceHeaderByRole(roleContext: PeriodRoleContext): ResourceHeaderBuilder {
  const capabilities = getCapabilities(roleContext.roles)
  return (period: PeriodDetailData) => buildResourceHeaderProps(period, capabilities)
}

function getColumnDefinitionByRole(
  roleContext: PeriodRoleContext | undefined
): ColumnDefinitionBuilder {
  const capabilities: Set<PlanningCapability> = roleContext
    ? getCapabilities(roleContext.roles)
    : new Set()
  return (sources?: ColumnDefinitionSources) => getColumnDefinition({ ...sources, capabilities })
}
